// ---------------------------------------------------------------
// Harvested content from www.avalontattoocollective.ca
// All data below is static (MOCK) for the frontend-first build.
// Later phases can swap this for API-driven content.
// ---------------------------------------------------------------

const WIX = "https://static.wixstatic.com/media/";

// Build a Wix image URL that preserves the studio's original framing (crop)
// but requests a higher-resolution render.
const wixImg = (file, crop, w = 1200, h = 800, name = "image.jpg") =>
  `${WIX}${file}/v1/${crop ? `crop/${crop}/` : ""}fill/w_${w},h_${h},al_c,q_85/${name}`;

export const studio = {
  name: "Avalon Tattoo Collective",
  shortName: "Avalon",
  tagline: "New Westminster's premiere tattoo shop.",
  description:
    "Custom state-of-the-art tattoo service using only the best products to produce the highest quality of tattoos.",
  welcomeTitle: "Welcome to Avalon Tattoo Collective",
  welcomeBody:
    "Here at Avalon we believe that every artist has their own vision; and we want that vision to become a reality. Our culture speaks to this creed, empowering all of our members to seek their utmost potential through growth and excellence.",
  address: {
    line1: "314 Sixth Street",
    city: "New Westminster",
    province: "BC",
    country: "Canada",
    full: "314 Sixth Street, New Westminster, BC, Canada",
  },
  hours: {
    label: "Monday - Sunday",
    open: "12pm",
    close: "8pm",
    display: "Monday - Sunday: 12pm - 8pm",
  },
  phone: "604-716-7635",
  phoneHref: "tel:+16047167635",
  mapsEmbed:
    "https://www.google.com/maps?q=314+Sixth+Street,+New+Westminster,+BC&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=314+Sixth+Street,+New+Westminster,+BC",
  bookingNote:
    "Please click the artist you wish to contact and follow the instructions.",
  images: {
    hero: wixImg("71f912_1e30a6a40e2947f28c55f4a4ffc3aede~mv2.jpg", null, 1920, 1200, "avalon-hero.jpg"),
    heroPortrait: wixImg("71f912_1e30a6a40e2947f28c55f4a4ffc3aede~mv2.jpg", null, 1200, 1500, "avalon-hero-portrait.jpg"),
    guestSpots: wixImg("3d5b91_6f356dd9232547e98e126936be8059ec.jpg", null, 1920, 1000, "avalon-guest-spots.jpg"),
    servicesPoster: wixImg("11062b_e12e778250c54ec0aa0d967b228e9cc3f000.jpg", null, 1920, 1080, "avalon-services.jpg"),
  },
  video: {
    services:
      "https://video.wixstatic.com/video/11062b_e12e778250c54ec0aa0d967b228e9cc3/1080p/mp4/file.mp4",
  },
};

export const services = {
  title: "Our Services",
  intro:
    "From custom designs to cover-ups, our artists can bring your ideas to life. We use the best inks and equipment to ensure a safe and clean experience.",
  items: [
    {
      id: "custom",
      title: "Custom Designs",
      body: "Bring your idea, reference, or a rough sketch. Our artists translate your vision into a one-of-a-kind piece drawn specifically for you.",
      icon: "PenTool",
    },
    {
      id: "coverups",
      title: "Cover-Ups & Reworks",
      body: "Old ink doesn't have to be forever. We specialize in transforming existing tattoos into something you're proud to wear.",
      icon: "Layers",
    },
    {
      id: "safe",
      title: "Safe & Clean",
      body: "Only the best inks and equipment, single-use needles, and a spotless studio so you can focus on the art.",
      icon: "ShieldCheck",
    },
  ],
};

export const styleFilters = [
  { id: "all", label: "All Artists" },
  { id: "black-grey", label: "Black & Grey Realism" },
  { id: "color", label: "Color" },
  { id: "watercolor", label: "Watercolor" },
  { id: "chicano", label: "Chicano / Pre-Hispanic" },
  { id: "junior", label: "Junior Artists" },
];

export const artists = [
  {
    id: "lud-bradley",
    name: "Lud Bradley",
    specialty: "Black and Grey Realism",
    tags: ["black-grey"],
    level: "artist",
    bookingUrl: "https://www.ludbradleytattoo.com/",
    bookingType: "website",
    bookingLabel: "ludbradleytattoo.com",
    image: wixImg("71f912_4caa226dcee248f893f2cf16bf42f32e~mv2.jpeg", "x_0,y_711,w_4426,h_2948", 1200, 800, "lud-bradley.jpg"),
  },
  {
    id: "leilani",
    name: "Leilani",
    specialty: "Color",
    tags: ["color"],
    level: "artist",
    bookingUrl: "https://leilanitattoos.com/",
    bookingType: "website",
    bookingLabel: "leilanitattoos.com",
    image: wixImg("71f912_062f744e147c42dfa9ef4e58bc6d43bc~mv2.jpeg", "x_0,y_359,w_2336,h_1556", 1200, 800, "leilani.jpg"),
  },
  {
    id: "ivy-jean",
    name: "Ivy Jean",
    specialty: "Black and Grey Realism",
    tags: ["black-grey"],
    level: "artist",
    bookingUrl: "https://www.ivyjeantattoo.com/",
    bookingType: "website",
    bookingLabel: "ivyjeantattoo.com",
    image: wixImg("71f912_6d3b8afb22d04a3e86f38885a1e09d4b~mv2.jpeg", "x_0,y_509,w_2336,h_1561", 1200, 800, "ivy-jean.jpg"),
  },
  {
    id: "zennie-pihl",
    name: "Zennie Pihl",
    specialty: "Water Color and Realism",
    tags: ["watercolor", "color"],
    level: "artist",
    bookingUrl: "https://zencustombodyart.com/",
    bookingType: "website",
    bookingLabel: "zencustombodyart.com",
    image: wixImg("71f912_1b65ab30b25548f180ef3b6bd63fc830~mv2.jpeg", "x_0,y_1214,w_4297,h_2863", 1200, 800, "zennie-pihl.jpg"),
  },
  {
    id: "jose-bandera",
    name: "Jose Bandera",
    specialty: "Black and Grey Chicano Pre Hispanic",
    tags: ["black-grey", "chicano"],
    level: "artist",
    bookingUrl: "https://www.instagram.com/josebandera",
    bookingType: "instagram",
    bookingLabel: "@josebandera",
    image: wixImg("71f912_18ce5de4d5f348389e4ed5f54dea3f10~mv2.jpg", "x_0,y_1484,w_4672,h_3122", 1200, 800, "jose-bandera.jpg"),
  },
  {
    id: "keila-soto",
    name: "Keila Soto",
    specialty: "Black and Grey Realism",
    tags: ["black-grey"],
    level: "artist",
    bookingUrl: "https://instagram.com/kstattoos_",
    bookingType: "instagram",
    bookingLabel: "@kstattoos_",
    image: wixImg("71f912_79417282b08141508eaf8c1e6a1414d9~mv2.jpeg", "x_0,y_576,w_2336,h_1561", 1200, 800, "keila-soto.jpg"),
  },
  {
    id: "ania-ray",
    name: "Ania Ray",
    specialty: "Black and Grey and Color Realism",
    tags: ["black-grey", "color"],
    level: "artist",
    bookingUrl: "https://www.instagram.com/ania_ray",
    bookingType: "instagram",
    bookingLabel: "@ania_ray",
    image: wixImg("71f912_c80d95ba372740b3abff2f06c9340724~mv2.jpg", "x_0,y_1461,w_4672,h_3122", 1200, 800, "ania-ray.jpg"),
  },
  {
    id: "jonah-regan",
    name: "Jonah Regan",
    specialty: "Black and Grey Realism",
    tags: ["black-grey"],
    level: "artist",
    bookingUrl: "https://www.instagram.com/thelittleinkertattoos",
    bookingType: "instagram",
    bookingLabel: "@thelittleinkertattoos",
    image: wixImg("71f912_70499fd171a740a5b8406a7cef364ea9~mv2.jpeg", "x_0,y_454,w_2336,h_1561", 1200, 800, "jonah-regan.jpg"),
  },
  {
    id: "braden-beard",
    name: "Braden Beard",
    specialty: "Black and Grey Realism",
    tags: ["black-grey", "junior"],
    level: "junior",
    bookingUrl: "https://www.instagram.com/bradenbeard_artwork",
    bookingType: "instagram",
    bookingLabel: "@bradenbeard_artwork",
    image: wixImg("71f912_88b68d43cd2e49bc977f4d9d12480cf6~mv2.jpg", "x_0,y_1007,w_4672,h_3122", 1200, 800, "braden-beard.jpg"),
  },
  {
    id: "juan-rodriguez",
    name: "Juan Rodriguez",
    specialty: "Black and Grey Realism",
    tags: ["black-grey"],
    level: "artist",
    bookingUrl: "https://www.instagram.com/jdejuan_tattoo",
    bookingType: "instagram",
    bookingLabel: "@jdejuan_tattoo",
    image: wixImg("71f912_3e2680e2774948989bc94e4a3340d416~mv2.jpg", "x_0,y_1428,w_4672,h_3122", 1200, 800, "juan-rodriguez.jpg"),
  },
  {
    id: "alicia-smith",
    name: "Alicia Smith",
    specialty: "Black and Grey Realism",
    tags: ["black-grey"],
    level: "artist",
    bookingUrl: "https://www.instagram.com/alicias.tattoos",
    bookingType: "instagram",
    bookingLabel: "@alicias.tattoos",
    image: wixImg("71f912_4c854f8430244b9b86f29e5a9331f18d~mv2.jpg", "x_0,y_1373,w_4672,h_3122", 1200, 800, "alicia-smith.jpg"),
  },
  {
    id: "naomi-burke",
    name: "Naomi Burke",
    specialty: "Black and Grey Realism",
    tags: ["black-grey", "junior"],
    level: "junior",
    bookingUrl: "https://www.instagram.com/naomiitattoos",
    bookingType: "instagram",
    bookingLabel: "@naomiitattoos",
    image: wixImg("71f912_7029a23cc2f049b19ca5f211136a49bb~mv2.jpg", "x_0,y_1594,w_4672,h_3122", 1200, 800, "naomi-burke.jpg"),
  },
];

export const guestSpots = {
  title: "Guest Spot Registry",
  subtitle: "Are you interested in joining our team?",
  intro: "Looking to work out of Avalon while you are on the road? Reach out!",
  formTitle: "Guest Spot Sign-Up",
  agreement:
    "I agree to uphold Avalon's ethos and standards of best practice, taking my clients' safety and wellbeing into account. I hold my art and clients' satisfaction to the highest regard.",
  successTitle: "Thanks for reaching out!",
  successBody:
    "We've received your guest spot request. A member of the Avalon team will be in touch.",
};

export const marqueeItems = [
  "Black & Grey Realism",
  "Color",
  "Watercolor",
  "Chicano",
  "Pre-Hispanic",
  "Custom Designs",
  "Cover-Ups",
  "Guest Spots",
  "New Westminster, BC",
];

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Artists", to: "/artists" },
  { label: "Services", to: "/#services" },
  { label: "Guest Spots", to: "/guest-spots" },
  { label: "Location", to: "/#location" },
  { label: "Contact", to: "/#contact" },
];
